// Common chart configuration for consistent styling across the app

export const commonChartColors = {
    primary: "#14B8A6",
    secondary: "#10B981",
    grid: "#E2E8F0",
    text: "#64748B",
    darkText: "#1E293B"
};

export const commonAxisStyle = {
    stroke: commonChartColors.text,
    style: { fontSize: '12px'},
    tickLine: false,
};

export const commonGridStyle = {
    strokeDasharray: "3 3",
    stroke: commonChartColors.grid,
    vertical: false
};

export const commonTooltipStyle = {
    contentStyle: {
        backgroundColor: 'white',
        border: `1px solid ${commonChartColors.grid}`,
        borderRadius: '8px',
        direction: 'rtl'
    }
};

export const commonLineStyle = {
    strokeWidth: 2,
    dot: { strokeWidth: 0, r: 5 },
    activeDot: { r: 7 }
};

// ApexCharts common configuration
export const apexChartsCommonConfig = {
    chart: {
        toolbar: {
            show: false
        },
        zoom: {
            enabled: false
        },
        fontFamily: '"Heebo", "Roboto", sans-serif'
    },
    dataLabels: {
        enabled: false
    },
    stroke: {
        curve: 'smooth',
        width: 2
    },
    fill: {
        type: 'gradient',
        gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.4,
            opacityTo: 0.05,
            stops: [0, 90, 100]
        }
    },
    grid: {
        borderColor: commonChartColors.grid,
        strokeDashArray: 3
    },
    xaxis: {
        labels: {
            style: {
                colors: commonChartColors.text,
                fontSize: '12px',
                fontFamily: '"Heebo", "Roboto", sans-serif'
            }
        }
    },
    yaxis: {
        labels: {
            style: {
                colors: commonChartColors.text,
                fontSize: '12px',
                fontFamily: '"Heebo", "Roboto", sans-serif'
            }
        }
    },
    tooltip: {
        theme: 'light',
        style: {
            fontSize: '12px',
            fontFamily: '"Heebo", "Roboto", sans-serif'
        }
    }
};